import {Component} from '@angular/core';

@Component({
  selector: 'app-sales-docs-credit-reports',
  templateUrl: './sales-docs-credit-reports.component.html',
})

export class SalesDocsCreditReportsComponent {

}
